var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"icon-btn-wrapper"},_vm.$listeners),[_c('i',{class:_vm.classNames})])
}
var staticRenderFns = []

export { render, staticRenderFns }